import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import Table from "../../components/Table";
import {
  viewPartners,
  deletePartners,
} from "../../../states/actions/partnersAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Avatar } from "@mui/material";
import Layout from "../layout/Layout";
import Loading from "../loading/Loading";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const ViewPartners = () => {
  // dispatch
  const dispatch = useDispatch();

  // hooks
  const partners = useSelector((state) => state.partners);
  // use effect
  useEffect(() => {
    dispatch(viewPartners());
  }, []);

  const navigate = useNavigate();

  const handleUpdateTeams = (data) => {
    navigate("/update-partners/" + data.id);
  };

  function handleRemoveTeams(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!",
      )
    ) {
      dispatch(deletePartners(data.id));
    }
    setTimeout(function () {
      dispatch(viewPartners());
    }, 1000);
  }
  const partnersColumns = [
    {
      accessorKey: "title", //access nested data with dot notation
      header: "Title",
    },

    {
      accessorKey: "detail", //access nested data with dot notation
      header: "Partner Detail",
    },
    {
      accessorKey: "photo", //access nested data with dot notation
      header: "Image",
      size: 100,
      Cell: ({ cell }) => (
        <div>
          <Avatar
            src={`${BaseUrl}${cell.getValue()}`.replace(/([^:]\/)\/+/g, "$1")}
            sx={{ width: 100, height: 100 }}
            variant="rounded"
          />
        </div>
      ),
    },
  ];
  const { t: translate } = useTranslation(["partners"]);
  return (
    <Layout title={"Partners"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">
            {translate("All Aderaw Addisu Partners")}
          </Typography>

          <Link to="/add-partners" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              sx={{ borderRadius: "5px" }}
            >
              {translate("Add Partner")}
            </Button>
          </Link>
        </Box>
        {partners?.partners ? (
          <Table
            data={partners?.partners}
            fields={partnersColumns}
            numberOfRows={partners?.partners?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveTeams}
            upDatefunction={handleUpdateTeams}
          />
        ) : (
          <Loading />
        )}
      </Box>
      <ToastContainer />
    </Layout>
  );
};

export default ViewPartners;
